import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.instant_change = (payload.instant_change === 'true') || (payload.instant_change === true)
  payload.is_enabled = parseInt(payload.is_enabled, 10)
  payload.instant_change_count = parseInt(payload.instant_change_count, 10)
  payload.group_id = parseInt(payload.group_id, 10)
  for (let el of payload.data) {
    el.free_balance = parseInt(el.free_balance, 10)
    el.min_balance = parseInt(el.min_balance, 10)
    el.service_id = parseInt(el.service_id, 10)
    el.tariff_id = parseInt(el.tariff_id, 10)
    el.use_free_balance = parseInt(el.use_free_balance, 10)
    el.use_min_balance = parseInt(el.use_min_balance, 10)
  }
}

var state = {
  switchTariffs: []
}

var getters = {
  SWITCH_TARIFFS: (state) => {
    return state.switchTariffs
  }
}

var mutations = {
  SET_SWITCH_TARIFFS: (state, payload) => {
    state.switchTariffs = payload
  }
}

var actions = {
  GET_SWITCH_TARIFFS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/switch_tariffs')
    if (result.status === 200) {
      context.commit('SET_SWITCH_TARIFFS', result.data)
    }
  },
  CREATE_SWITCH_TARIFFS: (context, payload) => {
    validation(payload)
    return axiosInstance.post('/settings/switch_tariffs', payload)
  },
  UPDATE_SWITCH_TARIFFS: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/switch_tariffs', payload)
  },
  DELETE_SWITCH_TARIFFS: (context, payload) => {
    return axiosInstance.delete('/settings/switch_tariffs?switch_tariff_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/switchTariff.js